var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.794 6.208l2.998 2.998L6.74 20.252 3 21l.748-3.74L14.794 6.207zm2.292-2.293a1.998 1.998 0 012.828 0l.172.17a2 2 0 010 2.829l-.88.878-2.998-2.999.878-.878z",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTQuNzk0IDYuMjA4bDIuOTk4IDIuOTk4TDYuNzQgMjAuMjUyIDMgMjFsLjc0OC0zLjc0TDE0Ljc5NCA2LjIwN3ptMi4yOTItMi4yOTNjLjc4MS0uNzgyIDIuMDQ4LS43ODIgMi44MjggMGwuMTcyLjE3Yy43ODEuNzgyLjc4MSAyLjA0OCAwIDIuODI5bC0uODguODc4LTIuOTk4LTIuOTk5Ljg3OC0uODc4eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzMzkgLTExNjcpIHRyYW5zbGF0ZSgxMjYxIDExNTUpIHRyYW5zbGF0ZSg3OCAxMikiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgEdit as ReactComponent };